import { lazy } from "react";
import CreatePassword from "../pages/createPassword";
import Logout from '../pages/logout';
import Register from "../pages/register";
const Login = lazy(() => import('../pages/login'));
const ForgotPassword = lazy(() => import('../pages/forgotPassword'));

export const AuthRoutes  = [
    {
        path: 'logout',
        element: <Logout />
    },
    {
        path: "login",
        element: <Login />
    },
    {
        path: "criar-conta",
        element: <Register />
    },
    {
        path: "confirma-conta/:token",
        element: <CreatePassword />
    },
    {
        path: "recuperar-senha",
        element: <ForgotPassword />
    }
]
